// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.75 3.5V12.5M8.5 3.5V12.5M2.75 8H8.5',
  'M10.9 7.2C12.05 6.2 14 6.65 14 8.05C14 9.15 13.1 9.55 12.15 9.55M12.15 9.55C13.15 9.55 14.1 9.95 14.1 11.05C14.1 12.6 12.05 13.05 10.75 12.05',
];
